import axios from "../utils/axios.wrapper";

export const getUsers = async () => {
  const { data } = await axios.get("/user/active");
  return data.items || data;
};

export const getUserById = async (id) => {
  const { data } = await axios.get(`/user/${id}`);
  return data;
};

export const createUser = async (user) => {
  const { data } = await axios.post("/user/create", user);
  return data;
};

export const updateUser = async (id, user) => {
  const { data } = await axios.put(`/user/${id}`, user);
  return data;
};

export const deleteUser = async (id) => {
  const { data } = await axios.delete(`/user/${id}`);
  return data;
};

export const changePassword = async (id, passwords) => {
  const { data } = await axios.post(`/user/changepassword`, {
    UserId: id,
    CurrentPassword: passwords.oldPassword,
    NewPassword: passwords.newPassword
  });
  return data;
};

export const attachUserToCustomer = async ({ userId, customerId }) => {
  const { data } = await axios.post("/user/attach-customer", {
    userId,
    customerId
  });
  return data;
};

export const getWaiters = async () => {
  const { data } = await axios.get("/user/waiters");
  return data.items || data;
};

export const importUsers = async (file) => {
  const formData = new FormData();
  formData.append('File', file); // Matches the backend FileUploadDto property name
  const { data } = await axios.post("/user/import", formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return data;
};

export const downloadUserTemplate = async () => {
  const response = await axios.get("/user/download-template", {
    responseType: 'blob',
  });
  return response;
};

export const userService = {
  getUsers,
  getUserById,
  createUser,
  updateUser,
  deleteUser,
  changePassword,
  attachUserToCustomer,
  getWaiters,
  importUsers, 
  downloadUserTemplate
};